module.exports = __webpack_public_path__ + "img/happy.5e620cfa.png";